import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createJSONStorage } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

interface UserSettingsStore {
  hideDeleteConfirmationDialog: boolean
  setHideDeleteConfirmationDialog: (hideDialog: boolean) => void
  regenerateDocumentTitle: boolean
  setRegenerateDocumentTitle: (regenerateDocumentTitle: boolean) => void
  defaultProcessingResolution: 'SD' | 'Original'
  setDefaultProcessingResolution: (resolution: 'SD' | 'Original') => void
  exportOrientation: 'Auto' | 'Portrait' | 'Landscape'
  setExportOrientation: (orientation: 'Auto' | 'Portrait' | 'Landscape') => void
  ssoOnlyByTenant: Record<string, boolean>
  setSsoOnly: (tenantId: string, ssoOnly: boolean) => void
}

export const useUserSettingsStore = create<UserSettingsStore>()(
  persist(
    immer((set) => ({
      hideDeleteConfirmationDialog: false,
      setHideDeleteConfirmationDialog: (hideDialog) =>
        set({ hideDeleteConfirmationDialog: hideDialog }),
      regenerateDocumentTitle: true,
      setRegenerateDocumentTitle: (regenerateDocumentTitle) =>
        set({ regenerateDocumentTitle }),
      defaultProcessingResolution: 'SD',
      setDefaultProcessingResolution: (resolution) =>
        set({ defaultProcessingResolution: resolution }),
      exportOrientation: 'Auto',
      setExportOrientation: (orientation) =>
        set({ exportOrientation: orientation }),
      ssoOnlyByTenant: {},
      setSsoOnly: (tenantId, ssoOnly) =>
        set((state) => {
          state.ssoOnlyByTenant[tenantId] = ssoOnly
        }),
    })),
    {
      name: 'user-settings-store',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
